

export       function generate_grid_response(zfolioMain, overwriteClass = '') {


  var regex = / dzs-l-layout--(.*?)-cols/g;


  var oout = {};


  let targetClass = zfolioMain.$itemsCon.attr('class');


  if(overwriteClass){
    targetClass = overwriteClass;
  }

  const detectGrid = regex.exec(targetClass);



  if (detectGrid) {
    var nr_cols = parseInt(detectGrid[1], 10);


    let percentGridItem = Number(100 / nr_cols).toFixed(4);

    if(zfolioMain.$gridSizer){

            // Get the CSS width of the grid sizer
      const gridSizerWidth = zfolioMain.$gridSizer.css('width');

      // Try to get the original CSS rule value
      const computedStyle = window.getComputedStyle(zfolioMain.$gridSizer[0]);
      const originalWidth = zfolioMain.$gridSizer[0].style.width || computedStyle.getPropertyValue('width');

      // Check if it's a percentage and overwrite percentGridItem
      if(originalWidth && originalWidth.includes('%')){
        const percentValue = parseFloat(originalWidth);
        if(!isNaN(percentValue)){
          percentGridItem = percentValue.toFixed(4);
        }
      }
    }

    const grid_unit_px = zfolioMain.tw / nr_cols;


    oout.nr_cols = nr_cols;
    oout.aux_iw = percentGridItem;
    oout.grid_unit_px = grid_unit_px;

  }

  return oout;
}
